import API from 'apiCalls/api'

export async function createPackage(body, token) {
  let response
  try {
    response = await API.post(`package/`, body, {
      headers: { Authorization: `token ${token}` },
    })
  } catch (error) {
    response = error.response
  }
  return response
}

export async function createDuplicatePackage(identifier, token) {
  let response
  try {
    response = await API.post(
      `duplicate_package/?identifier=${identifier}`,
      {},
      {
        headers: { Authorization: `token ${token}` },
      },
    )
  } catch (error) {
    response = error.response
  }
  return response
}

export async function getPackages(token, source) {
  let response = { data: { results: [], count: 0, next: null }, status: null }
  let allResults = []
  let nextPageUrl = `package/?limit=100&offset=0` // Initial endpoint with parameters

  try {
    while (nextPageUrl) {
      const currentResponse = await API.get(nextPageUrl, {
        headers: { Authorization: `token ${token}` },
        cancelToken: source.token,
      })

      if (currentResponse.status === 200) {
        const { results, next, count } = currentResponse.data
        allResults = [...allResults, ...results] // Aggregate results
        nextPageUrl = next ? new URL(next).pathname + new URL(next).search : null // Extract relative path
        if (nextPageUrl?.includes('/v2')) {
          nextPageUrl = nextPageUrl?.replace('/v2', '')
        }

        // Update response count and next as we progress
        response.data.count = count
        response.data.next = next
      } else {
        throw new Error(`Unexpected response status: ${currentResponse.status}`)
      }
    }

    // Set response structure
    response.data.results = allResults
    response.status = 200
  } catch (error) {
    console.error('Error fetching packages:', error)
    response = error.response || { data: { results: [], count: 0, next: null }, status: 500 }
  }

  return response
}

export async function getAllPackages(token, source) {
  let allResults = []
  let nextPageUrl = `package/?limit=50&offset=0` // Initial endpoint with parameters

  try {
    while (nextPageUrl) {
      const response = await API.get(nextPageUrl, {
        headers: { Authorization: `token ${token}` },
        cancelToken: source.token, // Add cancel token if needed
      })

      if (response.status === 200) {
        const { results, next } = response.data
        allResults = [...allResults, ...results] // Aggregate results
        nextPageUrl = next ? new URL(next).pathname + new URL(next).search : null // Extract relative path
        if (nextPageUrl?.includes('/v2')) {
          nextPageUrl = nextPageUrl?.replace('/v2', '')
        }
      } else {
        throw new Error(`Unexpected response status: ${response.status}`)
      }
    }
  } catch (error) {
    console.error('Error fetching all packages:', error)
  }

  return allResults
}

export async function getPackage(token, identifier) {
  let response
  try {
    response = await API.get(`package/${identifier}/`, {
      headers: { Authorization: `token ${token}` },
    })
  } catch (error) {
    response = error.response
  }
  return response
}

export async function getSinglePhotographerPublicPackages(UID) {
  let response
  try {
    response = await API.get(`photographer-public/${UID}/packages-public/`)
  } catch (error) {
    response = error.response
  }
  return response
}

export async function deletePackage(token, identifier) {
  let response
  try {
    response = await API.delete(`package/${identifier}/`, {
      headers: { Authorization: `token ${token}` },
    })
  } catch (error) {
    response = error.response
  }
  return response
}

export async function patchPackage(token, identifier, body) {
  // const formData = new FormData()
  // for (const key in body) {
  //   formData.append(key, body[key])
  // }
  let response
  try {
    response = await API.patch(`package/${identifier}/`, body, {
      headers: { Authorization: `token ${token}` },
    })
  } catch (error) {
    response = error.response
  }
  return response
}

export async function patchPackagePublic(identifier, body, source) {
  let response
  try {
    response = await API.patch(`package-public/${identifier}/`, body, {
      cancelToken: source.token,
    })
  } catch (error) {
    response = error.response
  }
  return response
}

export async function patchPackageStatus(token, identifier, status) {
  let response
  const body = {
    status: status,
  }

  try {
    response = await API.patch(`package/${identifier}/`, body, {
      headers: { Authorization: `token ${token}` },
    })
  } catch (error) {
    response = error.response
  }
  return response
}

export async function getPublicPackage(identifier) {
  let response
  try {
    response = await API.get(`package-public/${identifier}/`)
  } catch (error) {
    response = error.response
  }
  return response
}

export async function uploadNewPackageImage(form, identifier, token) {
  let response
  try {
    response = await API.post(`/package/${identifier}/images/`, form, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `token ${token}`,
      },
    })
  } catch (error) {
    response = error.response
  }
  return response
}

export async function deletePackageImage(image, identifier, token) {
  let response
  try {
    response = await API.delete(`/package/${identifier}/images/${image}`, {
      headers: {
        Authorization: `token ${token}`,
      },
    })
  } catch (error) {
    response = error.response
  }
  return response
}

export async function reorderImages(token, identifier, body) {
  let response
  try {
    response = await API.post(`/package/${identifier}/reorder-images/`, body, {
      headers: {
        Authorization: `token ${token}`,
      },
    })
  } catch (error) {
    response = error.response
  }
  return response
}

export async function getMarketplacePackages(params, source) {
  let response
  const paramValues = Object.keys(params)
    .map((key) => [key, params[key]].join('='))
    .join('&')
  try {
    response = await API.get(`/marketplace-package-list/?${paramValues}`, {
      cancelToken: source.token,
    })
  } catch (error) {
    response = error
  }
  return response
}

export async function getNextMarketplacePackages(URL, source) {
  let response
  try {
    response = await API.get(`${URL}`, {
      cancelToken: source.token,
    })
  } catch (error) {
    response = error
  }
  return response
}

export async function getLocalMarketplacePackages(params, source) {
  let response
  const paramValues = Object.keys(params)
    .map((key) => [key, params[key]].join('='))
    .join('&')
  try {
    response = await API.get(`/local-package-list/?${paramValues}`, {
      cancelToken: source.token,
    })
  } catch (error) {
    response = error
  }
  return response
}

export async function getNextLocalMarketplacePackages(URL, source) {
  let response
  try {
    response = await API.get(`${URL}`, {
      cancelToken: source.token,
    })
  } catch (error) {
    response = error
  }
  return response
}

export async function listExploreLocalPackages(params, source) {
  let response
  const paramValues = Object.keys(params)
    .map((key) => [key, params[key]].join('='))
    .join('&')
  try {
    response = await API.get(`/explore-local-package-list/?${paramValues}`, {
      cancelToken: source.token,
    })
  } catch (error) {
    response = error
  }
  return response
}

// HERE
export async function listNextExploreLocalPackages(URL, source) {
  let response
  try {
    response = await API.get(`${URL}`, {
      cancelToken: source.token,
    })
  } catch (error) {
    response = error
  }
  return response
}

export async function listExploreForeignPackages(params, source) {
  let response
  const paramValues = Object.keys(params)
    .map((key) => [key, params[key]].join('='))
    .join('&')
  try {
    response = await API.get(`/explore-foreign-package-list/?${paramValues}`, {
      cancelToken: source.token,
    })
  } catch (error) {
    response = error
  }
  return response
}

export async function listNextExploreForeignPackages(URL, source) {
  let response
  try {
    response = await API.get(`${URL}`, {
      cancelToken: source.token,
    })
  } catch (error) {
    response = error
  }
  return response
}

export async function getPackageTemplate(value) {
  let response
  try {
    response = await API.get(`/package_template/?keyword=${value}`)
    // response = await api.get(`gallery/${identifier}/`, {
    // }) // http://192.168.1.154:8000/v2/package_template/?keyword=wedding
  } catch (error) {
    response = error.response
  }
  return response
}
export async function getCategories() {
  let response
  try {
    response = await API.get(`/categories`)
    // response = await api.get(`gallery/${identifier}/`, {
    //   headers: { Authorization: `token ${token}` },
    // })
  } catch (error) {
    response = error.response
  }
  return response
}

export async function createFeaturePackage(token, blogId, body) {
  let response
  try {
    response = await API.post(`/blog/${blogId}/blog_featured_package/`, body, {
      headers: { Authorization: `token ${token}` },
    })
  } catch (error) {
    response = error.response
  }
  return response
}

export async function updateFeaturePackage(token, blogId, packId, body) {
  let response
  try {
    response = await API.patch(`/blog/${blogId}/blog_featured_package/${packId}/`, body, {
      headers: { Authorization: `token ${token}` },
    })
  } catch (error) {
    response = error.response
  }
  return response
}

export async function deleteFeaturePackage(token, blogId, packId) {
  let response
  try {
    response = await API.delete(`/blog/${blogId}/blog_featured_package/${packId}/`, {
      headers: { Authorization: `token ${token}` },
    })
  } catch (error) {
    response = error.response
  }
  return response
}
